import { useState } from "react";
import emailjs from "@emailjs/browser";
import "../styles/registration-form.css";
import Toast from "../components/Toast";

const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    fullName: "", // Họ và tên
    phone: "", // Số điện thoại liên hệ
    email: "", // Địa chỉ mail
    education: "", // [Tên công ty / doanh nghiệp]
    otherEducation: "", // [Mã số thuế]
    address: "", // Địa chỉ
    agreement: false,
  });

  const sendEmail = () => {
    const emailParams = {
      formName: "Form đăng ký Bao bì, thương hiệu (30.000.000)",
      fullName: `${formData.fullName}`,
      phone: `${formData.phone}`,
      email: `${formData.email}`,
      education: `Tên công ty: ${formData.education}`,
      message: `Mã số thuế: ${formData.message}`,
      address: `Địa chỉ: ${formData.address}`,
    };
    emailjs
      .send(
        "service_3oo6e54",
        "template_los1h9c",
        emailParams,
        "Fg2TttehiRc-XVVCL"
      )
      .then((response) => {
        console.log("Email sent!", response.status, response.text);
        setToast({
          message: "Gửi đăng ký thành công! Chúng tôi sẽ liên hệ sớm.",
          type: "success",
        });

        setFormData({
          fullName: "",
          phone: "",
          email: "",
          education: "",
          message: "",
          address: "",
          agreement: false,
        });
        setErrors({});
      })
      .catch((error) => {
        console.error("Email sending error:", error);
        setToast({
          message: "Gửi đăng ký thất bại, vui lòng thử lại!",
          type: "error",
        });
      });
  };

  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState(null);

  const validate = () => {
    const newErrors = {};
    if (!formData.fullName.trim())
      newErrors.fullName = "Họ và tên không thể để trống";
    if (!formData.phone.trim()) {
      newErrors.phone = "Số điện thoại không thể để trống";
    } else if (!/^\d{10,11}$/.test(formData.phone)) {
      newErrors.phone = "Số điện thoại không hợp lệ (10-11 số)";
    }
    if (!formData.email.trim()) newErrors.email = "Email không thể để trống";
    else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)
    )
      newErrors.email = "Email không hợp lệ";

    if (!formData.agreement)
      newErrors.agreement = "Bạn cần đồng ý với các điều khoản";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => {
      if (type === "checkbox") return { ...prev, [name]: checked };
      return { ...prev, [name]: value };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) sendEmail();
    else
      setToast({
        message: "Vui lòng kiểm tra lại các trường thông tin.",
        type: "error",
      });
  };

  return (
    <div className="registration-form-bg">
      <div className="registration-form">
        {toast && (
          <Toast
            message={toast.message}
            type={toast.type}
            onClose={() => setToast(null)}
          />
        )}

        <div className="registration-form__title-container">
          <h1
            id="registration-form"
            className="registration-form__title"
          >
            ĐĂNG KÝ
            <br />
            <span className="highlighted">
              Hỗ trợ bản quyền & sở hữu trí tuệ
            </span>
          </h1>
          <p className="registration-form__subtitle">TẠI HỌC VIỆN DESIGN24</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="registration-form__form"
        >
          {/* Họ và tên */}
          <div className="registration-form__field">
            <label
              htmlFor="fullName"
              className="registration-form__label"
            >
              Họ và tên <span className="required">*</span>
            </label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              className="registration-form__input"
              placeholder="Nguyễn Văn A"
              required
            />
            {errors.fullName && <div className="error">{errors.fullName}</div>}
          </div>

          {/* Số điện thoại */}
          <div className="registration-form__field">
            <label
              htmlFor="phone"
              className="registration-form__label"
            >
              Số điện thoại liên hệ <span className="required">*</span>
            </label>
            <input
              type="text"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="registration-form__input"
              placeholder="034 432 7071"
              required
            />
            {errors.phone && <div className="error">{errors.phone}</div>}
          </div>

          {/* Email */}
          <div className="registration-form__field">
            <label
              htmlFor="email"
              className="registration-form__label"
            >
              Email <span className="required">*</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="registration-form__input"
              placeholder="nguyenvana@gmail.com"
              required
            />
            {errors.email && <div className="error">{errors.email}</div>}
          </div>

          {/* Tên công ty */}
          <div className="registration-form__field">
            <label
              htmlFor="education"
              className="registration-form__label"
            >
              Tên công ty / doanh nghiệp
            </label>
            <input
              type="text"
              id="education"
              name="education"
              value={formData.education}
              onChange={handleChange}
              className="registration-form__input"
              placeholder="Công ty ABC"
            />
            {/* Chú thích: key 'education' dùng cho Tên công ty */}
          </div>

          {/* Mã số thuế */}
          <div className="registration-form__field">
            <label
              htmlFor="message"
              className="registration-form__label"
            >
              Mã số thuế
            </label>
            <input
              type="text"
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="registration-form__input"
              placeholder="0123456789"
            />
            {/* Chú thích: key 'message' dùng cho Mã số thuế */}
          </div>

          {/* Địa chỉ */}
          <div className="registration-form__field">
            <label
              htmlFor="address"
              className="registration-form__label"
            >
              Địa chỉ
            </label>
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              className="registration-form__input"
              placeholder="Tầm Vu, Hưng Lợi, Ninh Kiều, TP Cần Thơ"
            />
          </div>

          {/* Checkbox đồng ý */}
          <div className="registration-form__field">
            <label className="registration-form__checkbox-label">
              <input
                type="checkbox"
                name="agreement"
                checked={formData.agreement}
                onChange={handleChange}
              />
              Tôi đồng ý cung cấp thông tin để được tư vấn về các chương trình
              đào tạo tại Học viện Design24.
            </label>
            {errors.agreement && (
              <div className="error">{errors.agreement}</div>
            )}
          </div>

          {/* Submit */}
          <div className="registration-form__field">
            <button
              type="submit"
              className="registration-form__submit-button"
            >
              GỬI ĐĂNG KÝ
            </button>
          </div>
        </form>

        {/* Footer */}
        <div className="registration-form__footer">
          <p>
            Hotline tư vấn & hỗ trợ: <a href="tel:0704888009">0704 888 009</a> -{" "}
            <a href="tel:0784888009"> 0784 888 009</a>
          </p>
          <p>Địa chỉ: 166 Nguyễn Văn Cừ, Q. Ninh Kiều, TP. Cần Thơ, Việt Nam</p>
          <p>
            Website:{" "}
            <a
              href="https://www.design24.edu.vn"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.design24.edu.vn
            </a>{" "}
            | Fanpage: Học viện Design24
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationForm;
